module.exports = __webpack_public_path__ + "static/media/estee-janssens-aQfhbxailCs-unsplash.486459a9.jpg";